import styled from 'styled-components';

import { Icon, InputCheckbox } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Tooltip } from '@creditornot/cb-popover';
import { useMatchMedia } from 'common/hooks/useMatchMedia';

import { SelectMode } from './types';

const DragDropAndSelectColumn = styled.div`
  position: sticky;
  left: 0;
  background: ${color.bg};
  padding: 0;
  z-index: 1;
  padding-left: 12px;
`;

const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
`;

const DragDropAndSelectIcons = styled(IconsContainer)`
  padding: 12px 8px;
  gap: 16px;
`;

type Props = {
  selectionMode: SelectMode;
  handleToggleRow: (e: SelectMode) => void;
  handleRowDrag?: () => void;
  hasDragSelectColumn: boolean;
  className?: string;
  isSelectDisabled?: boolean;
  name?: string;
  disabledRowMessage?: string;
  role?: 'cell' | 'columnheader';
  hideSelection?: boolean;
};

export const RowDragSelect = ({
  selectionMode,
  handleToggleRow,
  handleRowDrag,
  hasDragSelectColumn,
  isSelectDisabled = false,
  className,
  name,
  disabledRowMessage,
  role = 'cell',
  hideSelection = false,
}: Props) => {
  const isMobile = useMatchMedia('maxMd');

  if (!hasDragSelectColumn) {
    return null;
  }

  const contentContainerClassName = `${className ?? ''} content-container`.trim();

  return (
    <DragDropAndSelectColumn role={role} className={contentContainerClassName}>
      <DragDropAndSelectIcons className="row-select">
        {!!handleRowDrag && !isMobile && <Icon source={icons.dragHandle.small} />}
        {!!handleToggleRow && !hideSelection && (
          <Tooltip
            content={disabledRowMessage}
            placement="bottom"
            disabled={!isSelectDisabled || !disabledRowMessage}
          >
            <InputCheckbox
              onChange={(e) => {
                handleToggleRow(e.target.checked ? 'ALL' : 'NONE');
              }}
              checked={selectionMode === 'ALL'}
              indeterminate={selectionMode === 'SOME'}
              disabled={isSelectDisabled}
              aria-label={role === 'columnheader' ? 'Select all rows' : 'Select row'}
              name={name}
            />
          </Tooltip>
        )}
      </DragDropAndSelectIcons>
    </DragDropAndSelectColumn>
  );
};
